export const emailValidationRegex =
  // eslint-disable-next-line no-useless-escape
  /^\w+([.-]?\w+)*(\+?\w+)?@[a-zA-Z0-9]+([.-]?[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,3})+$/;

export const hebrewTextValidationRegex = /^[\u0590-\u05FF\uFB1D-\uFB4F ׳]*$/;

export const validateEmail = (email: string) =>
  email.match(emailValidationRegex);

export const validateNumber = (value: string) => value.match("^[0-9]*$");

export const validateHebrewText = (value: string) =>
  value.match(hebrewTextValidationRegex);

export const formatStringDateBySeparate = (date: string) => {
  return date.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
};

export const validatePassword = (password: string) => {
  const passwordValidationRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/;
  return password.match(passwordValidationRegex);
}